import { FC } from 'react';

interface CallSummaryTextProps {
  summary: string;
}

const HIGHLIGHT_PATTERN = /(interest|buying|selling|real estate|agent|transferred)/gi;

export const CallSummaryText: FC<CallSummaryTextProps> = ({ summary }) => {
  if (!summary) return null;

  return (
    <div className="bg-green-50 dark:bg-green-900/20 p-3 rounded-lg border border-[#A8F3D0] dark:border-green-800/30">
      <p className="t-body text-foreground whitespace-pre-wrap">
        {summary.split('.').map((sentence, index, array) => {
          const trimmedSentence = sentence.trim();
          if (!trimmedSentence) return null;

          const parts = trimmedSentence.split(HIGHLIGHT_PATTERN);

          return (
            <span key={index} className="block mb-1.5 last:mb-0">
              {parts.map((part, i) =>
                HIGHLIGHT_PATTERN.test(part) ? (
                  <span key={i} className="text-green-800 dark:text-green-400 font-medium">
                    {part}
                  </span>
                ) : (
                  part
                )
              )}
              {'.'}
              {index < array.length - 1 ? ' ' : ''}
            </span>
          );
        })}
      </p>
    </div>
  );
};
